<template>
  <Modal :open="displayModal" title="Update User" size="large" modalIcon="fad fa-user"
    modalIconColor="bg-blue-100 text-blue-700" :showEscapeButton="true" :showAcceptButton="true" acceptButtonText="Update"
    :acceptButtonProgress="loading" @close="displayModal = false" @onSuccess="updateDetails" ref="modal">
    <div class="grid grid-cols-1 gap-4" v-if="userData !== null">
      <div>
        <label for="network_name" class="block text-sm font-medium text-gray-700">Name</label>
        <input type="text" name="network_name" id="network_name"
          class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
          v-model="userData.name" />
      </div>

      <div>
        <label for="user_email" class="block text-sm font-medium text-gray-700">Email</label>
        <input type="email" name="user_email" id="user_email"
          class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
          v-model="userData.email" />
      </div>

      <div>
        <label for="user_email" class="block text-sm font-medium text-gray-700">Permanent Embargo</label>
        <input type="email" name="user_email" id="user_email"
          class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
          v-model="userData.permanent_embargo" />
      </div>

      <div class="flex flex-row space-x-4 items-center pl-4">
        <input name="" id="viralDrmClient" type="checkbox"
          class="focus:ring-blue-500 h-4 w-4 text-blue-600 border-gray-300 rounded focus:outline-none"
          v-model="userData.viral_drm_client" />
        <label for="viralDrmClient" class="sm:text-sm">
          ViralDRM Client
        </label>
      </div>

      <div class="flex flex-row space-x-4 items-center pl-4">
        <input name="" id="displayPricingDefault" type="checkbox"
          class="focus:ring-blue-500 h-4 w-4 text-blue-600 border-gray-300 rounded focus:outline-none"
          v-model="userData.exempt_from_credit_agreements" />
        <label for="displayPricingDefault" class="sm:text-sm">
          Exclude this user from network credit agreements.
        </label>
      </div>

      <div>
        <label for="user_email" class="block text-sm font-medium text-gray-700">W-9 Receipt</label>
        <p>
          {{
            userData.w9_timestamp !== null
            ? userData.w9_timestamp
            : "No receipt."
          }}
        </p>
        <div class="w-full grid grid-cols-2 gap-4 mt-1">
          <button
            class="px-3 py-1.5 bg-blue-600 rounded-lg text-white col-span-1 disabled:opacity-25 disabled:cursor-not-allowed focus:outline-none"
            :disabled="userData.w9_timestamp !== null" @click="updateW9Receipt(true)">
            Record W-9 Receipt
          </button>
          <button
            class="px-3 py-1.5 bg-red-600 rounded-lg text-white col-span-1 disabled:opacity-25 disabled:cursor-not-allowed focus:outline-none"
            :disabled="userData.w9_timestamp == null" @click="updateW9Receipt(false)">
            Remove W-9 Receipt
          </button>
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
import * as Config from "@/config";
import { mapActions } from "vuex";

import Modal from "@/components/Modal";

export default {
  data() {
    return {
      displayModal: false,
      userData: null,
      loading: false
    };
  },

  components: {
    Modal
  },

  mounted() {
    this.$nextTick(
      function () {
        this.$eventBus.$on("admin-user-update-modal-open", this.open);
      }.bind(this)
    );
  },

  destroyed() {
    this.$eventBus.$off("admin-user-update-modal-open", this.open);
  },

  methods: {
    ...mapActions(["addToastMessage"]),
    open(data) {
      console.log(data);
      this.displayModal = true;
      this.userData = data;
    },

    async updateDetails() {
      this.loading = true;

      let res = await this.$http.patch(
        Config.apiPath + "/api/v2/admin/users/" + this.userData.id,
        {
          name: this.userData.name,
          email: this.userData.email,
          permanent_embargo: this.userData.permanent_embargo,
          exempt_from_credit_agreements: this.userData
            .exempt_from_credit_agreements,
          viral_drm_client: this.userData.viral_drm_client
        }
      );
      if (res.status == 200) {
        this.loading = false;

        this.addToastMessage({
          title: "Success",
          text: this.userData.name + "'s user details were updated.",
          type: "success"
        });

        this.displayModal = false;
      } else {
        this.addToastMessage({
          title: "Whoops!",
          text:
            this.userData.name +
            "'s user details were not updated due to an issue.",
          type: "error"
        });
      }
    },
    async updateW9Receipt(refeshVal) {
      let res = await this.$http.patch(
        Config.apiPath + "/api/v2/admin/users/" + this.userData.id,
        {
          w9refresh: refeshVal
        }
      );
      if (res.status == 200) {
        this.userData.w9_timestamp = res.data.w9_timestamp;
        this.addToastMessage({
          title: "Success",
          text: this.userData.name + "'s user details were updated.",
          type: "success"
        });
      } else {
        this.addToastMessage({
          title: "Whoops!",
          text:
            this.userData.name +
            "'s user details were not updated due to an issue.",
          type: "error"
        });
      }
    }
  }
};
</script>
